import instance from "../../axios";
import { errorHandler } from "../../Helpers";
import { notifyError } from "../../Utils/CustomNotifcations";

export const generateIdempotentKey = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const getTapContractNumber = (ServerSetting, logInUser) =>
  ServerSetting?.contractNumber || logInUser?.contractNumber || "";

export const getTapCurrency = (logInUser) =>
  logInUser?.attributes?.currencyLabel || "AED";

export const getBookingPaymentRedirectUrl = (bookingId) => {
  const params = new URLSearchParams({ returnTo: "maintenance" });
  if (bookingId != null && bookingId !== "") {
    params.set("bookingId", String(bookingId));
  }
  return `${window.location.origin}/payment/callback?${params.toString()}`;
};

export const normalizeTapUrl = (raw) => {
  if (!raw || typeof raw !== "string") return null;
  return raw.replace(/&amp;/g, "&");
};

export const extractTapPaymentResult = (res) => ({
  chargeId:
    res?.chargeId ||
    res?.charge_id ||
    res?.id ||
    res?.transaction?.id ||
    null,
  transactionUrl: normalizeTapUrl(
    res?.transactionUrl ||
      res?.transaction?.url ||
      res?.url ||
      res?.paymentUrl ||
      null,
  ),
  status: res?.status || "",
});

export const extractBookingId = (res) =>
  res?.id ||
  res?.service?.id ||
  res?.serviceId ||
  res?.bookingId ||
  null;

/** Backend uses camelCase `prePaid`. */
export const isPrepaidTrue = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const isPaidFalse = (value) =>
  value === false || value === "false" || value === 0 || value === "0";

export const getPrePaidFlag = (obj) =>
  isPrepaidTrue(obj?.prePaid ?? obj?.prepaid);

/**
 * Open Tap in a new tab. Pass a window opened synchronously on click
 * (`window.open("about:blank")`) so popup blockers do not block it.
 */
export const openTapCheckoutTab = (transactionUrl, tapWindow = null) => {
  const url = normalizeTapUrl(transactionUrl);
  if (!url) {
    if (tapWindow && !tapWindow.closed) tapWindow.close();
    return false;
  }
  if (tapWindow && !tapWindow.closed) {
    tapWindow.location.href = url;
    return true;
  }
  const opened = window.open(url, "_blank");
  if (opened) return true;
  window.location.assign(url);
  return true;
};

/**
 * POST /api/payments/tappayment for booking (type BOOKING) and open Tap checkout.
 */
export const initiateBookingTapPayment = ({
  dispatch,
  ServerSetting,
  logInUser,
  bookingId,
  amount,
  description = "",
  tapWindow = null,
}) => {
  const payload = {
    contractNumber: getTapContractNumber(ServerSetting, logInUser),
    amount: parseFloat(amount) || 0,
    currency: getTapCurrency(logInUser),
    redirectUrl: getBookingPaymentRedirectUrl(bookingId),
    invoiceId: "",
    description: description || "",
    idempotentKey: generateIdempotentKey(),
    type: "BOOKING",
    bookingId,
  };

  return instance({
    method: "POST",
    url: "/api/payments/tappayment",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: payload,
  })
    .then((res) => {
      const { chargeId, transactionUrl } = extractTapPaymentResult(res);
      if (chargeId) {
        sessionStorage.setItem("tapChargeId", String(chargeId));
      }
      if (bookingId != null && bookingId !== "") {
        sessionStorage.setItem("tapBookingId", String(bookingId));
      }
      sessionStorage.setItem("tapReturnTo", "maintenance");
      if (!openTapCheckoutTab(transactionUrl, tapWindow)) {
        if (dispatch) {
          dispatch(notifyError("somethingWentWrong"));
        }
      }
      return res;
    })
    .catch((error) => {
      if (tapWindow && !tapWindow.closed) {
        tapWindow.close();
      }
      if (dispatch) {
        errorHandler(error, dispatch);
      }
      throw error;
    });
};
